/*
 * kstent-color-gallery.js
 * Lightbox for COLOR VARIATION cards. Uses native <dialog> for focus trap + ESC.
 * Vanilla / no deps. Defer-loaded.
 */
(function () {
  var root = document.querySelector('.kstent-color-gallery');
  if (!root) return;
  var dialog = root.querySelector('[data-color-lightbox]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var img = dialog.querySelector('[data-color-lightbox-img]');
  var labelEl = dialog.querySelector('[data-color-lightbox-label]');
  var codeEl = dialog.querySelector('[data-color-lightbox-code]');
  var closeBtn = dialog.querySelector('[data-color-lightbox-close]');

  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-color-lightbox-trigger]');
    if (!trigger) return;
    img.src = trigger.dataset.imageSrc || '';
    img.alt = trigger.dataset.imageAlt || '';
    if (labelEl) labelEl.textContent = trigger.dataset.label || '';
    if (codeEl) codeEl.textContent = trigger.dataset.code || '';
    dialog.showModal();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dialog.close();
    });
  }

  dialog.addEventListener('click', function (e) {
    // backdrop click closes (clicks on inner figure won't bubble to dialog)
    if (e.target === dialog) dialog.close();
  });
})();
